/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="m10.035 9.214 2.625 2.625a.564.564 0 0 1 0 .817.63.63 0 0 1-.409.175.63.63 0 0 1-.408-.175L9.218 10.03c-.875.641-1.925 1.05-3.092 1.05a4.954 4.954 0 0 1-4.958-4.959 4.954 4.954 0 0 1 4.958-4.958 4.954 4.954 0 0 1 4.959 4.958 5.07 5.07 0 0 1-1.05 3.092M6.126 2.331a3.784 3.784 0 0 0-3.791 3.791c0 2.1 1.691 3.792 3.791 3.792 1.05 0 1.984-.408 2.684-1.108s1.108-1.634 1.108-2.684c0-2.1-1.692-3.791-3.792-3.791"
      clipRule="evenodd"
    />
    <mask
      id="search_svg__a"
      width={12}
      height={12}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m10.035 9.214 2.625 2.625a.564.564 0 0 1 0 .817.63.63 0 0 1-.409.175.63.63 0 0 1-.408-.175L9.218 10.03c-.875.641-1.925 1.05-3.092 1.05a4.954 4.954 0 0 1-4.958-4.959 4.954 4.954 0 0 1 4.958-4.958 4.954 4.954 0 0 1 4.959 4.958 5.07 5.07 0 0 1-1.05 3.092M6.126 2.331a3.784 3.784 0 0 0-3.791 3.791c0 2.1 1.691 3.792 3.791 3.792 1.05 0 1.984-.408 2.684-1.108s1.108-1.634 1.108-2.684c0-2.1-1.692-3.791-3.792-3.791"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#search_svg__a)">
      <path fill="#BABFC7" d="M0 0h14v14H0z" />
    </g>
  </svg>
)
export default SvgSearch
